//# sourceMappingURL=organization_setup.mjs.map
/// <reference types="./organization_setup.d.mts" />
import * as $ask from "../../../altar/altar/ask.mjs";
import * as $when from "../../../altar/altar/when.mjs";
import * as $utils from "../../../data_types/common/utils.mjs";
import * as $ai_config from "../../../data_types/data/ai_config.mjs";
import * as $qualification_matrix from "../../../data_types/data/qualification_matrix.mjs";
import * as $tag from "../../../data_types/data/tag.mjs";
import * as $decrypt from "../../../data_types/decrypt.mjs";
import * as $http from "../../../gleam_http/gleam/http.mjs";
import * as $promise from "../../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $bool from "../../../gleam_stdlib/gleam/bool.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $toast from "../../../redraw_toastify/toastify/toast.mjs";
import * as $function from "../../../tiamat/tiamat/function.mjs";
import * as $toast_effects from "../../admin/effects/toast.mjs";
import * as $middleware from "../../admin/middleware.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $store from "../../data/store.mjs";
import { toList } from "../../gleam.mjs";

export function set_defaults() {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          return $when.some_(
            store.organization,
            () => { return $promise.resolve(undefined); },
            (org_id) => {
              let _pipe = $ask.to(
                new $ask.Admin(),
                toList(["organizations", org_id, "setup"]),
              );
              let _pipe$1 = $ask.via(_pipe, new $http.Post());
              let _pipe$2 = $ask.bearing(_pipe$1, access_token);
              let _pipe$3 = $ask.with$(
                _pipe$2,
                (() => {
                  let org_id$1 = $json.string(org_id);
                  let config = $ai_config.encode_config(
                    $ai_config.default_config(),
                  );
                  return $json.object(
                    toList([
                      ["tags", $json.array($utils.default_tags, $json.string)],
                      [
                        "ai_config",
                        $json.object(
                          toList([["org_id", org_id$1], ["config", config]]),
                        ),
                      ],
                      [
                        "qualification_matrix",
                        $json.array(
                          $utils.default_qm_rows,
                          (row) => {
                            return $json.object(
                              toList([
                                ["id", $json.string("")],
                                ["org_id", $json.string("")],
                                ["title", $json.string(row.title)],
                                ["content", $json.string(row.content)],
                                ["qm_order", $json.int(row.order)],
                              ]),
                            );
                          },
                        ),
                      ],
                    ]),
                  );
                })(),
              );
              let _pipe$4 = $ask.expect(
                _pipe$3,
                $decode.field(
                  "ai_config",
                  $ai_config.decoder(),
                  (ai_config) => {
                    return $decode.field(
                      "tags",
                      $decode.list($decrypt.json($tag.decoder())),
                      (tags) => {
                        let qm = $decode.list(
                          $decrypt.json($qualification_matrix.decoder()),
                        );
                        return $decode.field(
                          "qualification_matrix",
                          qm,
                          (qm_rows) => {
                            let _pipe$4 = new $msg.ApiSavedDefaults(
                              org_id,
                              ai_config,
                              tags,
                              qm_rows,
                            );
                            let _pipe$5 = new $msg.OrganizationSetup(_pipe$4);
                            return $decode.success(_pipe$5);
                          },
                        );
                      },
                    );
                  },
                ),
              );
              let _pipe$5 = $ask.on_success(
                _pipe$4,
                (m) => {
                  dispatch(m);
                  return undefined;
                },
              );
              let _pipe$6 = $ask.run(_pipe$5);
              return $promise.map(_pipe$6, $function.constant(undefined));
            },
          );
        },
      );
    },
  );
}

export function add_tag(tag) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          return $when.some_(
            store.organization,
            () => { return $promise.resolve(undefined); },
            (org_id) => {
              let _pipe = $ask.to(
                new $ask.Admin(),
                toList(["organizations", org_id, "tags", "setup"]),
              );
              let _pipe$1 = $ask.via(_pipe, new $http.Post());
              let _pipe$2 = $ask.bearing(_pipe$1, access_token);
              let _pipe$3 = $ask.with$(_pipe$2, $json.string(tag));
              let _pipe$4 = $ask.expect(_pipe$3, $decode.list($tag.decoder()));
              let _pipe$5 = $ask.on_success(
                _pipe$4,
                (tags) => {
                  let _pipe$5 = new $msg.ApiReturnedOrganizationsTags(
                    org_id,
                    tags,
                  );
                  let _pipe$6 = new $msg.Organizations(_pipe$5);
                  dispatch(_pipe$6);
                  return undefined;
                },
              );
              let _pipe$6 = $ask.run(_pipe$5);
              return $promise.map(_pipe$6, $function.constant(undefined));
            },
          );
        },
      );
    },
  );
}

export function update_tag(tag, name) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let default$ = () => { return $promise.resolve(undefined); };
          return $when.some_(
            store.organization,
            default$,
            (org_id) => {
              return $bool.lazy_guard(
                org_id !== tag.org_id,
                default$,
                () => {
                  let _pipe = $ask.to(
                    new $ask.Heimdall(),
                    toList(["organizations", org_id, "tags", tag.id]),
                  );
                  let _pipe$1 = $ask.via(_pipe, new $http.Patch());
                  let _pipe$2 = $ask.bearing(_pipe$1, access_token);
                  let _pipe$3 = $ask.with$(_pipe$2, $json.string(name));
                  let _pipe$4 = $ask.expect(
                    _pipe$3,
                    $decode.list($tag.decoder()),
                  );
                  let _pipe$5 = $ask.on_success(
                    _pipe$4,
                    (tags) => {
                      let _pipe$5 = new $msg.ApiReturnedOrganizationsTags(
                        org_id,
                        tags,
                      );
                      let _pipe$6 = new $msg.Organizations(_pipe$5);
                      dispatch(_pipe$6);
                      return undefined;
                    },
                  );
                  let _pipe$6 = $ask.run(_pipe$5);
                  return $promise.map(_pipe$6, $function.constant(undefined));
                },
              );
            },
          );
        },
      );
    },
  );
}

export function remove_tag(tag) {
  return $effect.from_(
    (dispatch, get_state, dispatch_effect) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          return $when.some_(
            store.organization,
            () => { return $promise.resolve(undefined); },
            (org_id) => {
              dispatch(
                new $msg.OrganizationSetup(new $msg.UserRemovedTag(org_id, tag)),
              );
              let _pipe = $ask.to(
                new $ask.Admin(),
                toList(["organizations", org_id, "tags"]),
              );
              let _pipe$1 = $ask.via(_pipe, new $http.Delete());
              let _pipe$2 = $ask.bearing(_pipe$1, access_token);
              let _pipe$3 = $ask.with$(_pipe$2, $json.string(tag));
              let _pipe$4 = $ask.expect(_pipe$3, $decode.list($tag.decoder()));
              let _pipe$5 = $ask.on_error(
                _pipe$4,
                (_) => {
                  let err = "Can't delete tag as there is already a source tagged with it.";
                  dispatch_effect($toast_effects.toast(new $toast.Error(), err));
                  return undefined;
                },
              );
              let _pipe$6 = $ask.on_success(
                _pipe$5,
                (tags) => {
                  let _pipe$6 = new $msg.ApiReturnedOrganizationsTags(
                    org_id,
                    tags,
                  );
                  let _pipe$7 = new $msg.Organizations(_pipe$6);
                  dispatch(_pipe$7);
                  return undefined;
                },
              );
              let _pipe$7 = $ask.run(_pipe$6);
              return $promise.map(_pipe$7, $function.constant(undefined));
            },
          );
        },
      );
    },
  );
}

export function fetch_qualification_matrix(org_id) {
  return $effect.from(
    (dispatch, get_state) => {
      let store = get_state();
      return $middleware.require_access_token(
        store.client,
        (access_token) => {
          let _pipe = new $msg.ApiStartedLoadingQualificationMatrix(org_id);
          let _pipe$1 = new $msg.OrganizationSetup(_pipe);
          dispatch(_pipe$1);
          let _pipe$2 = $ask.to(
            new $ask.Admin(),
            toList(["organizations", org_id, "qualification-matrix"]),
          );
          let _pipe$3 = $ask.via(_pipe$2, new $http.Get());
          let _pipe$4 = $ask.bearing(_pipe$3, access_token);
          let _pipe$5 = $ask.expect(
            _pipe$4,
            $decode.list($qualification_matrix.decoder()),
          );
          let _pipe$6 = $ask.on_success(
            _pipe$5,
            (qm_rows) => {
              let _pipe$6 = new $msg.ApiReturnedQualificationMatrix(
                org_id,
                qm_rows,
              );
              let _pipe$7 = new $msg.OrganizationSetup(_pipe$6);
              dispatch(_pipe$7);
              return undefined;
            },
          );
          return $ask.run(_pipe$6);
        },
      );
    },
  );
}
